import { render, staticRenderFns } from "./UploadFileAction.vue?vue&type=template&id=321271f4&"
import script from "./UploadFileAction.vue?vue&type=script&lang=js&"
export * from "./UploadFileAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports